import React from 'react';

import { observer } from 'mobx-react';

import { bind } from 'bind-decorator';

import { MenuItem, Menu as MuiMenu } from '@material-ui/core';
import type { MenuProps } from '@material-ui/core';

import type { IMenuItem } from './nested-sub-menu-item';
import SubMenuItem from './nested-sub-menu-item';

export interface IProps extends MenuProps {
  menuItems?: (IMenuItem | JSX.Element)[];
}

@observer
class BzMenu extends React.Component<IProps> {
  @bind
  renderItems(): React.ReactNode {
    const { menuItems } = this.props;
    if (menuItems == null) {
      return null;
    }

    return menuItems.map((menuItem) => {
      if (!menuItem.hasOwnProperty('caption') && !menuItem.hasOwnProperty('onClick')) {
        return menuItem as React.ReactNode; // nasty hack for FileTree rendering, hopefully short term
      }

      return this.renderMenuItems(menuItem as IMenuItem);
    });
  }

  @bind
  renderMenuItems(menuItem: IMenuItem): JSX.Element {
    if (menuItem.hasOwnProperty('menuItems')) {
      return (
        <SubMenuItem
          key={menuItem.key}
          caption={menuItem.caption}
          menuItems={menuItem.menuItems!}
        />
      );
    }

    return (
      <MenuItem key={menuItem.key} disabled={menuItem.disabled} onClick={menuItem.onClick}>
        {menuItem.caption}
      </MenuItem>
    );
  }

  render() {
    const { anchorEl, open, onClose, children, menuItems, ...others } = this.props;
    return (
      <MuiMenu anchorEl={anchorEl} open={open} onClose={onClose} {...others}>
        {this.renderItems()}
        {children}
      </MuiMenu>
    );
  }
}

export default BzMenu;

/* Example of menuItems:
[
    {
        'key': 'item1',
        'caption': 'Item 1',
        'onClick': (event) => function () {
        }
    },
    {
        'key': 'item2',
        'caption': 'Item 2',
        'onClick': (event) => function () {
        }
    },
    {
        'key': 'item3',
        'caption': 'Item 3',
        'subMenuItems': [
            {
                'key': 'item1',
                'caption': 'Item 1',
                'onClick': (event) => function () {
                }
            },
            {
                'key': 'item2',
                'caption': 'Item 2',
                'onClick': (event) => function () {
                }
            }
        ]
    }
];
 */
